module.exports = __webpack_public_path__ + "img/116013.bcb31a2a.png";